export default "__VITE_ASSET__D6sw62Kn__"